export const COMPONENT_NAME = 'OurRecommendation';